import DataGrid, { Column, FilterPanel, FilterRow, HeaderFilter, Pager, Paging, Sorting } from 'devextreme-react/data-grid';
import Toolbar, { Item } from "devextreme-react/toolbar";
import React, { useEffect, useReducer, useState, useRef } from 'react';
import { useSelector } from 'react-redux';
import { Confirm } from 'semantic-ui-react';
import { mauThuKetQuaApi } from '../../../api/mauThuKetQuaApi';
import { DangerButton, DefaultButton, PrimaryButton } from '../../../components/editor/button';
import { useCommonContext } from '../../../contexts/common';
import { showNotify } from "../../../helpers/toast";
import styles from "./MauThuTuyenSinh.module.css";
import MauThuDetailModal from "./mau-thu-detail-modal";

const iniState = {
    mauthu_ketquas: [],
    selected_mauthu_ketqua: {},
};
const actionTypes = {
    SET_MAUTHU_KETQUAS: 'SET_MAUTHU_KETQUAS',
    SET_SELECTED_MAUTHU_KETQUA: 'SET_SELECTED_MAUTHU_KETQUA',
};
const reducer = (state, action) => {
    switch (action.type) {
        case actionTypes.SET_MAUTHU_KETQUAS:
            return {
                ...state,
                mauthu_ketquas: action.payload
            };
        case actionTypes.SET_SELECTED_MAUTHU_KETQUA:
            return {
                ...state,
                selected_mauthu_ketqua: action.payload,
            };
        default:
            return state;
    }
}

const MauThuTuyenSinhPage = () => {
    const [mauThuTuyenSinhs, setMauThuTuyenSinhs] = useState([]);
    const { dm_coso_id } = useSelector(x => x.coSo);
    const { nam_hoc } = useSelector(x => x.namHoc);
    const grid = useRef(null);

    const [isShowEditModal, setisShowEditModal] = useState();
    const [isShowPreviewModal, setisShowPreviewModal] = useState(false);
    const [isLoading, setisLoading] = useState(false);

    const [mauThuTuyenSinhEditing, setMauThuTuyenSinhEditing] = useState();
    const [state, dispatch] = useReducer(reducer, iniState);
    const [isShowConfirmDelete, setIsShowConfirmDelete] = useState(false);
    const { canAccessTo, translate } = useCommonContext();

    useEffect(() => {
        if (isLoading) {
            grid.current.instance.beginCustomLoading();
        } else {
            grid.current.instance.endCustomLoading();
        }
    }, [isLoading]);
    useEffect(() => {
        handleLoadMauThuTuyenSinhs();
    }, [dm_coso_id, nam_hoc])
    const handleLoadMauThuTuyenSinhs = async () => {
        setisLoading(true)
        const res = await mauThuKetQuaApi.SelectAllAsync(dm_coso_id, nam_hoc);
        setisLoading(false)

        if (res.is_success) {
            setMauThuTuyenSinhs(res.data)
            dispatch({ type: actionTypes.SET_MAUTHU_KETQUAS, payload: res.data });
        }
    }
    const confirmDelete = async () => {
        const res = await mauThuKetQuaApi.Delete(state.selected_mauthu_ketqua.id);
        if (res.is_success) {
            handleLoadMauThuTuyenSinhs();
            setIsShowConfirmDelete(false);
        } else {
            showNotify({ text: res.message, type: "error" });
        }
    };
    const btnEdit_click = (data) => {
        setMauThuTuyenSinhEditing(data)
        setisShowEditModal(true)
    };
    const btnDelete_click = (data) => {
        dispatch({ type: actionTypes.SET_SELECTED_MAUTHU_KETQUA, payload: data });
        setIsShowConfirmDelete(true)
    };
    const cellRender = (data) => {
        return (
            <div>
                {/* {canAccessTo('api/email-template', HttpMethod.PUT) && ( */}
                <span
                    style={{ cursor: 'pointer' }}
                    onClick={() => {
                        btnEdit_click(data.data);
                    }}
                >
                    <i aria-hidden='true' className='icon edit'></i>{' '}
                </span>
                {/* )}
                {canAccessTo(EMAIL_TEMPLATE_ENDPOIT + '/{id}', HttpMethod.DELETE) && ( */}
                <span
                    style={{ cursor: 'pointer' }}
                    onClick={() => {
                        btnDelete_click(data.data);
                    }}
                >
                    <i aria-hidden='true' className='icon trash'></i>{' '}
                </span>
                {/* )} */}
            </div>
        );
    };
    const previewRender = (data) => {
        return (
            <div>
                <span
                    style={{ cursor: 'pointer', fontSize: '18px' }}
                    onClick={() => {
                        btnPreview_click(data.data);
                    }}
                >
                    <i aria-hidden="true" className="fa fa-eye" style={{ color: '#54CA7D' }}></i>{' '}
                </span>
            </div>
        );
    };
    const previewRenderEN = (data) => {
        return (
            <div>
                <span
                    style={{ cursor: 'pointer', fontSize: '18px' }}
                    onClick={() => {
                        btnPreview_click(data.data);
                    }}
                >
                    <i aria-hidden="true" className="fa fa-eye" style={{ color: '#54CA7D' }}></i>{' '}
                </span>
            </div>
        );
    };
    const btnPreview_click = (data) => {
        setisShowEditModal(true);
        setisShowPreviewModal(true);
        setMauThuTuyenSinhEditing(data)
    };
    return (
        <div className={styles.container}>
            <div className={styles.toolbar}>
                <Toolbar>
                    <Item location={"before"}>
                        <span className={styles.caption}>Danh sách các mẫu thư tuyển sinh</span>
                    </Item>
                    <Item location={"after"}>
                        <PrimaryButton text={"Thêm mẫu mới"} icon={'fas fa-plus'} onClick={() => {
                            setisShowEditModal(true)
                            setMauThuTuyenSinhEditing(undefined)
                        }} />
                    </Item>
                    <Item location={"after"}>
                        <DefaultButton text={"Tải lại dữ liệu"} icon={'fas fa-sync'} onClick={() => {
                            handleLoadMauThuTuyenSinhs()
                        }} />
                    </Item>
                </Toolbar>
            </div>
            <DataGrid
                ref={grid}
                keyExpr="id"
                dataSource={mauThuTuyenSinhs}
                columnHidingEnabled={false}
                columnAutoWidth={false}
                showBorders={true}
                showColumnLines={true}
                showRowLines={true}
                rowAlternationEnabled={true}
                allowColumnResizing={true}
                columnResizingMode={'nextColumn'}
                hoverStateEnabled={true}
                focusedRowEnabled={false}
                height={window.innerHeight - 150}
                className={'table-noborder-left'}
                wordWrapEnabled={false}
            // onSelectionChanged={onLopSelectionChanged}
            >
                <Column
                    cellRender={cellRender}
                    caption={"Thao tác"}
                    minWidth={70}
                    width={'auto'}
                ></Column>,

                {/* <Column minWidth={350} dataField={"subject"} caption={"Subject"} cellRender={(cell) => {
                        return <Link to={`/send-email-detail/${cell.data.ts_email_template_id}/${cell.data.id}`}>
                            {cell.data.subject}
                        </Link>
                    }} /> */}
                <Column minWidth={200} dataField={"ten_truong"} caption={"Tên trường"} />
                <Column minWidth={500} dataField={"ten_mau"} caption={"Tên mẫu thư"} />
                <Column width={300} caption={"Nội dung tiếng Việt"} alignment={'center'} cellRender={previewRender}
                />
                <Column width={300} caption={"Nội dung tiếng Anh"} alignment={'center'} cellRender={previewRenderEN}
                />
                <Sorting mode="single" />
                <Paging defaultPageSize={30} />
                <FilterRow visible={true} />
                <FilterPanel visible={true} />
                <HeaderFilter visible={true} />
                <Pager
                    showPageSizeSelector={true}
                    allowedPageSizes={[10, 20, 50]}
                    infoText={`${translate('Trang')} {0} /{1} ({2} ${translate(
                        'dòng'
                    )})`}
                    showInfo={true}
                />
            </DataGrid>
            {isShowEditModal &&
                <MauThuDetailModal
                    isPreview={isShowPreviewModal}
                    mauThuTuyenSinh={mauThuTuyenSinhEditing}
                    onClose={() => {
                        setisShowEditModal(false)
                        setisShowPreviewModal(false);

                    }}
                    onSuccess={() => {
                        setisShowEditModal(false)
                        handleLoadMauThuTuyenSinhs();
                    }
                    }
                />
            }
            <Confirm
                open={isShowConfirmDelete}
                dimmer={'blurring'}
                header={translate('Lưu ý')}
                content={translate('Bạn có chắc chắn muốn xóa dữ liệu ?')}
                size="mini"
                cancelButton={() => {
                    return (
                        <DefaultButton text={"Đóng"} onClick={() => {
                            setIsShowConfirmDelete(false);
                        }} />
                    );
                }}
                confirmButton={() => {
                    return (
                        <DangerButton text={"Xóa đăng ký"} onClick={confirmDelete} />

                    );
                }}
            />
        </div>
    );
};

export default MauThuTuyenSinhPage;